import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import * as moment from 'moment';
import { CustomDateComponent } from '../reports/customdate/custom-date.component';
import { MatDialogConfig } from '@angular/material';
var PumpindividualComponent = /** @class */ (function () {
    function PumpindividualComponent(ngxLoader, pumpservice, matDialog, globalService) {
        this.ngxLoader = ngxLoader;
        this.pumpservice = pumpservice;
        this.matDialog = matDialog;
        this.globalService = globalService;
        this.dataList = [{ "transformerDetails": "BH-1131", "pump": ["pump1", "pump2"], "params": ["current", "DEtemp", "NDEtemp", "phaseTemp", "sumpLevel", "waterLevel", "dischargePressureLow", "overLoad", "voltage", "waterFlow"] }, { "transformerDetails": "DG-001", "pump": ["pump1", "pump2"], "params": ["current", "DEtemp", "NDEtemp", "phaseTemp", "sumpLevel", "waterLevel", "dischargePressureLow", "overLoad", "voltage", "waterFlow"] }];
        this.paramList = this.dataList[0].params;
        this.durationList = [
            { id: 1, name: 'Today' },
            { id: 2, name: 'Yesterday' },
            { id: 3, name: 'This Week' },
            { id: 4, name: 'This Month' },
            { id: 5, name: 'Last Month' },
            { id: 6, name: 'Custom' }
        ];
        this.selectedDuration = this.durationList[0];
        this.pumpList = this.dataList[0].pump;
        this.currentUserData = JSON.parse(localStorage.getItem('userData'));
        this.data = [];
        this.graphValue = [];
        this.buchhlozSrc = "";
        this.abSrc = "";
        this.isLighting = false;
        this.isPumpOn = false;
        this.isDischarge = false;
        this.graph = {
            layout: {
                title: "",
                autosize: true,
                responsive: true,
                xaxis: {
                    title: {
                        text: 'Time',
                        font: {
                            family: 'Arial',
                            size: 18,
                            color: '#000000',
                        }
                    },
                },
                yaxis: {
                    title: {
                        text: 'Value',
                        font: {
                            family: 'Arial',
                            size: 18,
                            color: '#000000'
                        }
                    }
                },
                shapes: []
            },
            config: { displaylogo: false, modeBarButtonsToRemove: ['zoom2d', 'pan2d', 'select2d', 'lasso2d', 'toggleSpikelines', 'hoverClosestCartesian', 'hoverCompareCartesian'] }
        };
        this.lightningTransformerFeedback = 0;
        this.buchholz = 1;
        this.pumponestatus = 0;
        this.abswitch = 0;
        this.timeselection = {
            type: "Today",
            startDate: "",
            endDate: ""
        };
        this.totalPumpOnTimeInHours = 0;
        this.totalPumpOnTimeInMinutes = 0;
        this.totalPumpOnTimeInSeconds = 0;
        this.totalPumpOnTimeInDays = 0;
    }
    PumpindividualComponent.prototype.ngOnInit = function () {
        this.ngxLoader.startLoader('indgraph');
        this.getListofTransformerInitial();
        this.getpumpIds();
    };
    //*******************************NEW CODE**************************************/
    PumpindividualComponent.prototype.getListofTransformerInitial = function () {
        var _this = this;
        var payloadtogetTransformer = {
            "countryid": this.selectedCountry ? this.selectedCountry.id : null,
            "stateid": null,
            "cityid": null,
            "zoneid": null,
            "locationid": null,
            "transformerid": null,
        };
        this.globalService.getfilteredTransformers(JSON.stringify(payloadtogetTransformer), localStorage.getItem('userData')).subscribe(function (response) {
            if (response && response.code === '1' && response.result.length > 0) {
                _this.transformerList = response.result;
                _this.transformerList.map(function (e) {
                    e.label = e.transformerid + "[ " + e.sitename + " ]";
                });
                _this.selectedTransformerForHealth = response.result[0];
            }
        });
    };
    PumpindividualComponent.prototype.calculatePumpOnTime = function (data) {
        var pumpOnTime = 0;
        var startTime = null;
        data.forEach(function (record) {
            // Remove extra quotation marks from the date string
            var cleanedDate = record.Date.replace(/'/g, '');
            if (record.pumponffeedback === 1) {
                if (startTime === null) {
                    startTime = new Date(cleanedDate);
                }
            }
            else {
                if (startTime !== null) {
                    var endTime = new Date(cleanedDate);
                    pumpOnTime += (endTime.getTime() - startTime.getTime()) / 1000;
                    startTime = null;
                }
            }
        });
        // If pump was still on at the end of the data period
        if (startTime !== null) {
            var endTime = new Date(data[data.length - 1].Date.replace(/'/g, ''));
            pumpOnTime += (endTime.getTime() - startTime.getTime()) / 1000;
        }
        this.convertSecondsToTimeUnits(pumpOnTime);
        return pumpOnTime;
    };
    PumpindividualComponent.prototype.convertSecondsToTimeUnits = function (totalSeconds) {
        this.totalPumpOnTimeInDays = Math.floor(totalSeconds / 86400);
        totalSeconds %= 86400;
        this.totalPumpOnTimeInHours = Math.floor(totalSeconds / 3600);
        totalSeconds %= 3600;
        this.totalPumpOnTimeInMinutes = Math.floor(totalSeconds / 60);
        this.totalPumpOnTimeInSeconds = totalSeconds % 60;
        console.log("Total On Time:", this.totalPumpOnTimeInDays + " days, " +
            (this.totalPumpOnTimeInHours + " hours, ") +
            (this.totalPumpOnTimeInMinutes + " minutes, and ") +
            (this.totalPumpOnTimeInSeconds + " seconds"));
    };
    PumpindividualComponent.prototype.OnFilterChange = function (value, type) {
        var _this = this;
        if (type === "pump") {
            var data = { "pumpid": value, "duration": this.timeselection };
            this.pumpservice.gatewayReport(data).subscribe(function (response) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var parsedData, lastReading, dateStr, dateObj, currentTime, timeDifference;
                return tslib_1.__generator(this, function (_a) {
                    if (!response || !response.result || !Array.isArray(response.result)) {
                        console.error("Invalid response format:", response);
                        return [2 /*return*/];
                    }
                    parsedData = response.result.map(function (element) {
                        try {
                            return JSON.parse(element.pumpreadings);
                        }
                        catch (error) {
                            console.error("Error parsing pump readings:", element.pumpreadings, error);
                            return null;
                        }
                    }).filter(function (element) { return element !== null; });
                    if (parsedData.length === 0) {
                        this.hasData = false;
                        console.warn("No valid pump readings found in the response.");
                        return [2 /*return*/];
                    }
                    console.log("response", response.result);
                    this.totalPumpOnTime = this.calculatePumpOnTime(parsedData);
                    lastReading = parsedData[parsedData.length - 1];
                    if (lastReading) {
                        this.buchholz = lastReading.Transformer_buchholz_Act;
                        this.abswitch = lastReading.AB_Switch_On_Feedback;
                        this.lightningTransformerFeedback = lastReading.Lighting_Transformer_On_Feedback;
                        this.showcurrent = lastReading.pumponffeedback === 1;
                        dateStr = lastReading["Date"].replace(/'/g, '');
                        dateObj = new Date(dateStr);
                        currentTime = new Date();
                        timeDifference = currentTime.getTime() - dateObj.getTime();
                        this.pumponestatus = timeDifference <= 30 * 60 * 1000
                            ? lastReading.pumponffeedback
                            : 0;
                    }
                    else {
                        console.warn("No last reading data available.");
                        return [2 /*return*/];
                    }
                    if (response.result.length > 0) {
                        this.jsonReadings = parsedData;
                        this.jsonReadings.forEach(function (element) {
                            if (element.pumponffeedback == 0) {
                                element.L1 = 0;
                                element.L2 = 0;
                                element.L3 = 0;
                            }
                        });
                        this.dateAray = parsedData.map(function (element) { return element.Date; });
                        this.hasData = this.dateAray.length > 0;
                        this.updateSelected("motorrphasetemperature");
                    }
                    else {
                        this.hasData = false;
                    }
                    return [2 /*return*/];
                });
            }); }, function (error) {
                console.error("Error fetching gateway report:", error);
            });
        }
    };
    PumpindividualComponent.prototype.getpumpIds = function () {
        var _this = this;
        var data = { "roleid": this.currentUserData.roleid, "userid": this.currentUserData.userid };
        this.pumpservice.getPumpIds(data).subscribe(function (response1) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (response1.result.length > 0) {
                    this.pumpIdsArray = response1.result.map(function (pump) { return pump.pump_id; });
                }
                this.selectedpump = this.pumpIdsArray[0];
                this.OnFilterChange(this.selectedpump, "pump");
                console.log("called from line no 254");
                return [2 /*return*/];
            });
        }); });
    };
    //*******************************OLD CODE**************************************/
    PumpindividualComponent.prototype.onDurationChange = function () {
        this.ngxLoader.startLoader('indgraph');
        var selectedDuration = this.selectedDuration;
        console.log('Selected Duration:', selectedDuration);
        this.timeselection.type = selectedDuration.name;
        var duration = this.calculateDuration(selectedDuration);
        this.timeselection.startDate = duration.startdate;
        this.timeselection.endDate = duration.enddate;
        this.OnFilterChange(this.selectedpump, 'pump'); // Assuming you have a method like this
    };
    PumpindividualComponent.prototype.calculateDuration = function (selectedDuration) {
        var _this = this;
        var startdate, enddate, filters;
        switch (selectedDuration.id) {
            case 1: // Today
                startdate = moment().format('YYYY-MM-DD');
                enddate = moment().format('YYYY-MM-DD');
                filters = 'Today';
                break;
            case 2: // Yesterday
                startdate = moment().subtract(1, 'day').format('YYYY-MM-DD');
                enddate = moment().subtract(1, 'day').format('YYYY-MM-DD');
                filters = 'Yesterday';
                break;
            case 3: // This Week
                startdate = moment().startOf('week').format('YYYY-MM-DD');
                enddate = moment().endOf('week').format('YYYY-MM-DD');
                filters = 'This Week';
                break;
            case 4: // This Month
                startdate = moment().startOf('month').format('YYYY-MM-DD');
                enddate = moment().endOf('month').format('YYYY-MM-DD');
                filters = 'This Month';
                break;
            case 5: // Last Month
                startdate = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
                enddate = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
                filters = 'Last Month';
                break;
            case 6: // Custom
                var dialogConfig = new MatDialogConfig();
                var dialogRef = this.matDialog.open(CustomDateComponent, {
                    autoFocus: false,
                    height: '350px',
                    width: '450px'
                });
                dialogRef.afterClosed().subscribe(function (value) {
                    if (value) {
                        startdate = value.startDate;
                        enddate = value.endDate;
                        filters = 'Custom';
                        _this.timeselection.type = filters;
                        _this.timeselection.startDate = startdate;
                        _this.timeselection.endDate = enddate;
                        _this.OnFilterChange(_this.selectedpump, 'pump'); // Assuming you have a method like this
                    }
                });
                break;
            default:
                // Handle default case
                break;
        }
        return { startdate: startdate, enddate: enddate, filters: filters };
    };
    PumpindividualComponent.prototype.updateSelected = function (selectedParameter) {
        this.selectedParameter = selectedParameter;
        this.createGraph();
    };
    PumpindividualComponent.prototype.formatTitle = function (str) {
        // Define a map of input strings to their formatted versions
        var titleMap = {
            "motorrphasetemperature": "Motor  Phase Temperature",
            "pumpcurrent": "Current",
            "motorndetemperature": "Motor Nde Temperature",
            "motordetemperature": "Motor De Temperature",
            "pumpdplow": "Pump Discharge Pressure Low",
            "overload": "Overload",
            "Water_Flow": "Water Flow",
            "Sump_Level": "Sump Level",
            "pumponffeedback": "Pump On Off Feedback"
        };
        if (titleMap.hasOwnProperty(str)) {
            return titleMap[str];
        }
    };
    PumpindividualComponent.prototype.createGraph = function () {
        var param = this.selectedParameter;
        console.log("param original", param);
        this.graph.layout = {
            title: this.formatTitle(param),
            xaxis: {
                title: {
                    text: 'Time',
                    font: {
                        family: 'Arial',
                        size: 18,
                        color: '#000000',
                    }
                },
            },
            yaxis: {
                title: {
                    text: 'Value',
                    font: {
                        family: 'Arial',
                        size: 18,
                        color: '#000000'
                    }
                }
            },
        };
        var pumpCurrentArray = this.jsonReadings.map(function (pump) { return pump[param]; });
        if (param == "pumpcurrent") {
            pumpCurrentArray = this.jsonReadings.map(function (pump) { return ((pump['L1'] + pump['L2'] + pump['L3']) / 3).toFixed(2); });
        }
        if (param != 'motorrphasetemperature') {
            if (pumpCurrentArray.length === 0 || this.dateAray.length === 0) {
                this.ngxLoader.stopLoader('indgraph');
                return;
            }
            this.data = [{
                    x: this.dateAray,
                    y: pumpCurrentArray,
                    type: 'scatter',
                    text: param,
                    mode: 'lines+markers',
                    marker: { color: 'blue' }
                }];
        }
        else {
            var pumpRPhaseArray = this.jsonReadings.map(function (pump) { return pump[param]; });
            var pumpYPhaseArray = this.jsonReadings.map(function (pump) { return pump['motoryphasetemperature']; });
            var pumpBPhaseArray = this.jsonReadings.map(function (pump) { return pump['motorbphasetemperature']; });
            if (pumpRPhaseArray.length === 0 && pumpYPhaseArray.length === 0 && pumpBPhaseArray.length === 0 || this.dateAray.length === 0) {
                this.ngxLoader.stopLoader('indgraph');
                return;
            }
            this.data = [
                {
                    x: this.dateAray,
                    y: pumpRPhaseArray,
                    name: "R Phase",
                    type: 'scatter',
                    mode: 'lines+markers',
                    marker: { color: 'red' }
                },
                {
                    x: this.dateAray,
                    y: pumpYPhaseArray,
                    name: "Y Phase",
                    type: 'scatter',
                    mode: 'lines+markers',
                    marker: { color: 'yellow' }
                },
                {
                    x: this.dateAray,
                    y: pumpBPhaseArray,
                    name: "B Phase",
                    type: 'scatter',
                    mode: 'lines+markers',
                    marker: { color: 'blue' }
                }
            ];
        }
        this.ngxLoader.stopLoader('indgraph'); // Stop the loader after setting the data
    };
    return PumpindividualComponent;
}());
export { PumpindividualComponent };
